import { useState } from 'react';
import { hotDeals } from '@/mocks/hotDeals';

export default function HotDeals() {
  const [added, setAdded] = useState<string | null>(null);

  const handleAdd = (id: string) => {
    setAdded(id);
    setTimeout(() => setAdded(null), 1800);
  };

  return (
    <section id="hot-deals" className="bg-cream-50 py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14 md:mb-18">
          <span className="inline-block border border-gold-400 text-gold-500 text-sm font-sans-body tracking-widest px-4 py-1.5 rounded-full mb-5 font-medium">
            LIMITED OFFERS
          </span>
          <h2 className="font-serif-title text-[1.5rem] md:text-[2.125rem] text-warm-900 font-semibold leading-[1.4] mb-4">
            限時 Outlet 特惠
          </h2>
          <p className="font-sans-body text-[1.1875rem] text-warm-900/65 leading-[1.75] max-w-lg mx-auto">
            精選品牌下架款與換季庫存，全數正品直送，把握入手良機
          </p>
        </div>

        {/* Deals Grid */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
          data-product-shop
        >
          {hotDeals.map((deal) => (
            <div
              key={deal.id}
              className="group bg-white rounded-2xl overflow-hidden border border-cream-200 hover:border-gold-200 transition-all duration-300"
            >
              {/* Image Area */}
              <div className="relative w-full h-[280px] md:h-[320px] overflow-hidden bg-cream-50">
                <img
                  src={deal.image}
                  alt={deal.name}
                  title={`${deal.brand} ${deal.name} - Outlet特惠`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                {/* Tag Badge */}
                <span className="absolute top-3 left-3 bg-warm-900 text-white text-xs font-sans-body px-3 py-1 rounded-full font-medium whitespace-nowrap">
                  {deal.tag}
                </span>
                {/* Discount Badge */}
                <span className="absolute top-3 right-3 bg-gold-400 text-white text-xs font-sans-body font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  -{deal.discount}%
                </span>
              </div>

              {/* Info */}
              <div className="p-5">
                <p className="font-sans-body text-[1rem] text-gold-500 tracking-wider mb-1 font-medium">
                  {deal.brand}
                </p>
                <h3 className="font-serif-title text-[1.0625rem] md:text-[1.125rem] text-warm-900 font-semibold leading-[1.5] mb-3">
                  {deal.name}
                </h3>

                {/* Price */}
                <div className="flex items-baseline gap-3 mb-4">
                  <span className="font-sans-body text-[1.25rem] font-semibold text-warm-900">
                    NT$ {deal.salePrice.toLocaleString()}
                  </span>
                  <span className="font-sans-body text-[1rem] text-warm-900/40 line-through">
                    NT$ {deal.originalPrice.toLocaleString()}
                  </span>
                </div>

                {/* Add to Cart */}
                <button
                  onClick={() => handleAdd(deal.id)}
                  className={`whitespace-nowrap w-full py-2.5 rounded-full text-[1rem] font-medium font-sans-body transition-all duration-300 cursor-pointer ${
                    added === deal.id
                      ? 'bg-gold-400 text-white'
                      : 'bg-warm-900 text-white hover:bg-gold-500'
                  }`}
                >
                  {added === deal.id ? (
                    <span className="flex items-center justify-center gap-2">
                      <i className="ri-check-line"></i> 已加入購物車
                    </span>
                  ) : (
                    '加入購物車'
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* View All */}
        <div className="text-center mt-12">
          <button className="whitespace-nowrap font-sans-body text-[1.0625rem] font-medium border border-warm-900 text-warm-900 px-10 py-3 rounded-full hover:bg-warm-900 hover:text-white transition-all duration-300 cursor-pointer">
            查看全部特惠商品
          </button>
        </div>
      </div>
    </section>
  );
}
